export type TQuickExportParamsResult =
  | { ok: true; params: Record<string, unknown> }
  | { ok: false; errorMessage: string };

export type TQuickExportRunResult =
  | { ok: true }
  | { ok: false; errorMessage: string };

export function isQuickExportParamsFailure(
  result: TQuickExportParamsResult,
): result is { ok: false; errorMessage: string } {
  return result.ok === false;
}

export function isQuickExportRunFailure(
  result: TQuickExportRunResult,
): result is { ok: false; errorMessage: string } {
  return result.ok === false;
}
